import { Box } from "@mui/material";
import NextLink from "next/link";
import ReactHtmlParser from "@/src/utils/html-parser";
import { FONT_TEXT } from "@/src/components/common/broadsheet/tokens";
import Panel from "@/src/components/common/broadsheet/panel";

const ArticleCopyrightStatement = ({
  statement,
  doi,
}: {
  statement?: {
    caption: string;
  };
  doi?: string;
}) => {
  if (!statement?.caption && !doi) return null;

  return (
    <Panel
      component="aside"
      aria-label="Ordering reprints"
      tone="custom.kicker"
      sx={{
        mt: 0.75,
        fontFamily: FONT_TEXT,
        fontSize: "0.8125rem",
        lineHeight: 1.6,
        color: "custom.inkMuted",
        "& p:first-of-type": { mt: 0 },
        "& p:last-of-type": { mb: 0 },
        "& h1, & h2, & h3, & h4, & h5, & h6": {
          fontSize: "0.6875rem",
          fontWeight: 700,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          color: "custom.inkMuted",
          mb: 0.25,
        },
      }}
    >
      {statement?.caption ? ReactHtmlParser(statement.caption) : null}
      {doi ? (
        <Box
          component={NextLink}
          href={`https://marketplace.copyright.com/rs-ui-web/mp/search/all/${encodeURIComponent(doi)}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: "inline-block",
            mt: 0.375,
            fontSize: "0.8125rem",
            color: "custom.link",
            textDecoration: "none",
            paddingBlock: "0.1875rem",
            "&:hover": {
              color: "custom.linkHover",
              textDecoration: "underline",
              textUnderlineOffset: "0.15em",
            },
          }}
        >
          Licensing and reuse information
        </Box>
      ) : null}
    </Panel>
  );
};

export default ArticleCopyrightStatement;
